import React from "react";

function Header() {
  return (
    <div className="fixed w-[100%] lg:h-[6rem] h-[3.5rem] text-center z-20 bg-black flex justify-center align-middle items-center">
      <h1 className=" text-[2rem] font-bold text-white lg:text-[3rem]">
        GAMES DEPOT
      </h1>
    </div>
  );
}

export default Header;
